import { random } from 'lodash';
import { compose, pure, withProps } from 'recompose';
import getClientEnvironment from '../../../getClientEnvironment';
import { withAnimationContextProvider } from '../../withAnimationContext';
import LazyActivityMap from '../ActivityScene/ActivityMap/LazyActivityMap';
import {
    ActivityMapContainerProps,
    CustomStreamType,
    StravaResolution,
    StravaStreamType,
    UnitsPreference
} from '../types';
import { withFrontPageMapStreams } from './withDemoActivityStreams';

const config = getClientEnvironment();

// Stream types available for the front page
const yAxisStreamTypes = [StravaStreamType.altitude, CustomStreamType.pace];

// Props to display the front page map
const frontPageMapProps = {
    autoplayAnimation: true,
    color: config.THEME_COLOR,
    offsetBottomPercent: 50,
    offsetRightBreakpoint: 991,
    offsetRightPercent: 30,
    resolution: StravaResolution.medium,
    showNavigationControls: true,
    unitsPreference: UnitsPreference.imperial,
    xAxisStreamTypes: [StravaStreamType.distance, StravaStreamType.time] as (
        | StravaStreamType.distance
        | StravaStreamType.time)[],
    // Toss a coin to decide what y-axis stream to display
    yAxisStreamType: yAxisStreamTypes[random(0, yAxisStreamTypes.length - 1)]
};

export default compose<ActivityMapContainerProps, {}>(
    withProps(() => frontPageMapProps),
    withFrontPageMapStreams,
    // Add animation context
    withAnimationContextProvider,
    // Only update for props changes -
    // otherwise it updates on every animation frame,
    // which we don't want at this level
    pure
)(LazyActivityMap);



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/DemoActivityMap.tsx